<template>
    <content-view
        class="screenDetail"
    >
        <div class="bg-white pl32 pr32 pt32">
            <div class="text-black-85 font-big bold pb24">分辨率信息</div>
            <a-form
                @submit="handleSubmit"
                :form="form"
            >
                <a-form-item
                    class="form-item"
                    label="分辨率："
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 11 }"
                >
                    <a-row type="flex">
                        <a-col :span="6">
                            <a-form-item>
                                <a-input
                                    placeholder="请输入"
                                    onfocus="this.removeAttribute('readonly');"
                                    v-decorator="[
                                        'siz_wide',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请输入宽',
                                                    max:12
                                                }
                                            ]
                                        }
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="1" style="text-align: center;">
                            X
                        </a-col>
                        <a-col :span="6">
                            <a-form-item>
                                <a-input
                                    placeholder="请输入"
                                    onfocus="this.removeAttribute('readonly');"
                                    v-decorator="[
                                        'siz_long',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请输入高',
                                                    max:12
                                                }
                                            ]
                                        }
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    
                </a-form-item>
                <a-form-item
                    label='区域：'
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 6 }"
                >
                    <a-select
                        placeholder="请选择区域"
                        v-decorator="[
                            'district_code',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message:'请选择区域',

                                    }
                                ]
                            }
                        ]"
                    >
                        <a-select-option
                            v-for="item in statusList"
                            :value="item.district_code"
                            :key="item.district_code"
                        >
                            {{item.district}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item class="text-center footerButton pt24">
                    <a-button
                        class="mr16"
                        @click="cancel"
                    >取 消</a-button>
                    <a-button
                        type="primary"
                        htmlType="submit"
                    >确 定</a-button>
                </a-form-item>
            </a-form>
            
        </div>
    </content-view>
</template>

<script>
export default {
    name: "screenDetail",
    data() {
        return {
            isEdit: false,
            id: "",
            form: this.$form.createForm(this),
            statusList:[],
            detail:{},
        };
    },
    watch: {

    },
    methods: {
        // 获得区域列表
        getRole() {
            this.$api.common.regionList().then(res => {
                this.statusList = res.data.list;
            });
        },
        
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                    if (this.isEdit) {
                        values.id = this.id;
                    }
                    this.$api.screenvga.screenSet(values).then(res => {
                        if(res.data.error_no){
                            this.$message.error(res.msg);
                        }else{
                            this.$message.success(res.msg);
                            this.$router.push({
                                name: "screenvgaList"
                            });
                        }
                        
                    });
                    
                }
            });
        },
        // 取消
        cancel() {
            this.$utils.showConfirm(() => {
                this.$router.push({
                    name: "screenvgaList"
                });
            }, this);
        },
        getDetail() {
            let formData = {
                district_code:this.id
            }
            this.$api.screenvga.screenInfo(formData).then(res => {
                this.detail = res.data;
                let arr = ["siz_wide", "siz_long","district_code"];
                this.form.setFieldsValue(
                    this.$utils.getRequestData(arr, res.data)
                );
            });
        },
    },
    computed: {},
    created() {
        this.getRole();
        if (this.$route.query.district_code) {
            this.isEdit = true;
            this.id = this.$route.query.district_code;
            this.getDetail();
        } 
    }
};
</script>


<style rel="stylesheet/scss" lang="scss">
.wrap-container > div{
    flex: auto;
}
.screenDetail {
    .bold {
        font-weight: bold;
    }
    .ant-upload.ant-upload-drag {
        height: 202px;
    }
    .ant-upload.ant-upload-drag .ant-upload {
        padding: 0;
    }
    .icon-add {
        font-size: 40px;
    }
    .image {
        height: 200px;
    }
    .ant-checkbox-wrapper {
        width: 175px;
    }
    .editbtn {
        color: rgba(8, 106, 204, 1);
    }
}
.ql-picker,
.ql-picker-label {
    line-height: 24px;
}
</style>
